import { render } from "./itemEdit.vue?vue&type=template&id=c5064b02&ts=true"
import script from "./itemEdit.vue?vue&type=script&lang=ts"
export * from "./itemEdit.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__